var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _path6, _g5, _path7, _g6, _path8, _path9, _g7, _path10, _g8, _path11, _path12, _g9, _path13, _g10, _path14, _g11, _path15, _g12, _path16, _g13, _path17, _g14, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChrome = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13103_6309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 69,
    height: 69
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1112 68.0008C52.8889 68.0008 68.1111 52.7785 68.1111 34.0009C68.1111 15.2232 52.8889 0.000976562 34.1112 0.000976562C15.3336 0.000976562 0.111328 15.2232 0.111328 34.0009C0.111328 52.7785 15.3336 68.0008 34.1112 68.0008Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13103_6309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.50977 0.000976562V41.7281H20.7286L34.1122 18.5464H68.1121V0.000976562H5.50977Z",
    fill: "#DB4437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50977 0.000976562V41.7281H20.7286L34.1122 18.5464H68.1121V0.000976562H5.50977Z",
    fill: "url(#paint0_linear_13103_6309)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13103_6309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 69,
    height: 69
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1112 68.0008C52.8889 68.0008 68.1111 52.7785 68.1111 34.0009C68.1111 15.2232 52.8889 0.000976562 34.1112 0.000976562C15.3336 0.000976562 0.111328 15.2232 0.111328 34.0009C0.111328 52.7785 15.3336 68.0008 34.1112 68.0008Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13103_6309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0953 41.5926L5.70651 15.2002L5.48242 15.5866L20.7592 41.7819L21.0953 41.5926Z",
    fill: "#3E2723",
    fillOpacity: 0.15
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_13103_6309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 69,
    height: 69
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1112 68.0008C52.8889 68.0008 68.1111 52.7785 68.1111 34.0009C68.1111 15.2232 52.8889 0.000976562 34.1112 0.000976562C15.3336 0.000976562 0.111328 15.2232 0.111328 34.0009C0.111328 52.7785 15.3336 68.0008 34.1112 68.0008Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_13103_6309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.111328 68.0002H32.4769L47.4987 52.9784V41.7276H20.7276L0.111328 6.36768V68.0002Z",
    fill: "#0F9D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.111328 68.0002H32.4769L47.4987 52.9784V41.7276H20.7276L0.111328 6.36768V68.0002Z",
    fill: "url(#paint1_linear_13103_6309)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_13103_6309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 69,
    height: 69
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1112 68.0008C52.8889 68.0008 68.1111 52.7785 68.1111 34.0009C68.1111 15.2232 52.8889 0.000976562 34.1112 0.000976562C15.3336 0.000976562 0.111328 15.2232 0.111328 34.0009C0.111328 52.7785 15.3336 68.0008 34.1112 68.0008Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_13103_6309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.1863 42.2416L46.8657 42.0562L32.0332 68.0004H32.4775L47.1979 42.2532L47.1863 42.2416Z",
    fill: "#263238",
    fillOpacity: 0.15
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_13103_6309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 69,
    height: 69
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1112 68.0008C52.8889 68.0008 68.1111 52.7785 68.1111 34.0009C68.1111 15.2232 52.8889 0.000976562 34.1112 0.000976562C15.3336 0.000976562 0.111328 15.2232 0.111328 34.0009C0.111328 52.7785 15.3336 68.0008 34.1112 68.0008Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_13103_6309)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_13103_6309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 48,
    height: 62
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.110352 67.9997H32.4759L47.4977 52.978V41.7271H20.7267L0.110352 6.36719V67.9997Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_13103_6309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1099 18.5464L47.4974 41.7281L32.4756 68.0008H68.1098V18.5464H34.1099Z",
    fill: "#FFCD40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1099 18.5464L47.4974 41.7281L32.4756 68.0008H68.1098V18.5464H34.1099Z",
    fill: "url(#paint2_linear_13103_6309)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_13103_6309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 69,
    height: 69
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1112 68.0008C52.8889 68.0008 68.1111 52.7785 68.1111 34.0009C68.1111 15.2232 52.8889 0.000976562 34.1112 0.000976562C15.3336 0.000976562 0.111328 15.2232 0.111328 34.0009C0.111328 52.7785 15.3336 68.0008 34.1112 68.0008Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_13103_6309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1109 18.5459L47.4983 41.7276L32.4766 68.0003H68.1108V18.5459H34.1109Z",
    fill: "#FFCD40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1109 18.5459L47.4983 41.7276L32.4766 68.0003H68.1108V18.5459H34.1109Z",
    fill: "url(#paint3_linear_13103_6309)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_13103_6309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 69,
    height: 69
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1112 68.0008C52.8889 68.0008 68.1111 52.7785 68.1111 34.0009C68.1111 15.2232 52.8889 0.000976562 34.1112 0.000976562C15.3336 0.000976562 0.111328 15.2232 0.111328 34.0009C0.111328 52.7785 15.3336 68.0008 34.1112 68.0008Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_13103_6309)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_13103_6309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 18,
    width: 37,
    height: 51
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1099 18.5459L47.4974 41.7276L32.4756 68.0003H68.1098V18.5459H34.1099Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_13103_6309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.50879 0.000976562V41.7281H20.7276L34.1112 18.5464H68.1111V0.000976562H5.50879Z",
    fill: "#DB4437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50879 0.000976562V41.7281H20.7276L34.1112 18.5464H68.1111V0.000976562H5.50879Z",
    fill: "url(#paint4_linear_13103_6309)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_13103_6309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 69,
    height: 69
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1112 68.0008C52.8889 68.0008 68.1111 52.7785 68.1111 34.0009C68.1111 15.2232 52.8889 0.000976562 34.1112 0.000976562C15.3336 0.000976562 0.111328 15.2232 0.111328 34.0009C0.111328 52.7785 15.3336 68.0008 34.1112 68.0008Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_13103_6309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1113 18.5459V26.6402L64.4021 18.5459H34.1113Z",
    fill: "url(#paint5_radial_13103_6309)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_13103_6309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 69,
    height: 69
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1112 68.0008C52.8889 68.0008 68.1111 52.7785 68.1111 34.0009C68.1111 15.2232 52.8889 0.000976562 34.1112 0.000976562C15.3336 0.000976562 0.111328 15.2232 0.111328 34.0009C0.111328 52.7785 15.3336 68.0008 34.1112 68.0008Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_13103_6309)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_13103_6309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 0,
    width: 64,
    height: 42
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51074 0.00195312V15.5878L20.7296 41.7291L34.1132 18.5474H68.113V0.00195312H5.51074Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_13103_6309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.112305 68.0012H32.4779L47.4997 52.9794V41.7285H20.7286L0.112305 6.36865V68.0012Z",
    fill: "#0F9D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.112305 68.0012H32.4779L47.4997 52.9794V41.7285H20.7286L0.112305 6.36865V68.0012Z",
    fill: "url(#paint6_linear_13103_6309)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_13103_6309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 69,
    height: 69
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1112 68.0008C52.8889 68.0008 68.1111 52.7785 68.1111 34.0009C68.1111 15.2232 52.8889 0.000976562 34.1112 0.000976562C15.3336 0.000976562 0.111328 15.2232 0.111328 34.0009C0.111328 52.7785 15.3336 68.0008 34.1112 68.0008Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_13103_6309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.50977 15.6294L27.629 37.7448L20.7286 41.7282L5.50977 15.6294Z",
    fill: "url(#paint7_radial_13103_6309)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_13103_6309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 69,
    height: 69
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1112 68.0008C52.8889 68.0008 68.1111 52.7785 68.1111 34.0009C68.1111 15.2232 52.8889 0.000976562 34.1112 0.000976562C15.3336 0.000976562 0.111328 15.2232 0.111328 34.0009C0.111328 52.7785 15.3336 68.0008 34.1112 68.0008Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_13103_6309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5 67.9577L40.5982 37.7441L47.4986 41.7275L32.5 67.9577Z",
    fill: "url(#paint8_radial_13103_6309)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_13103_6309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 69,
    height: 69
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1112 68.0008C52.8889 68.0008 68.1111 52.7785 68.1111 34.0009C68.1111 15.2232 52.8889 0.000976562 34.1112 0.000976562C15.3336 0.000976562 0.111328 15.2232 0.111328 34.0009C0.111328 52.7785 15.3336 68.0008 34.1112 68.0008Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_13103_6309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1127 49.4549C42.648 49.4549 49.5672 42.5357 49.5672 34.0004C49.5672 25.4651 42.648 18.5459 34.1127 18.5459C25.5774 18.5459 18.6582 25.4651 18.6582 34.0004C18.6582 42.5357 25.5774 49.4549 34.1127 49.4549Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1126 46.3639C40.9408 46.3639 46.4762 40.8285 46.4762 34.0003C46.4762 27.1721 40.9408 21.6367 34.1126 21.6367C27.2844 21.6367 21.749 27.1721 21.749 34.0003C21.749 40.8285 27.2844 46.3639 34.1126 46.3639Z",
    fill: "#4285F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_13103_6309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 69,
    height: 69
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1112 68.0008C52.8889 68.0008 68.1111 52.7785 68.1111 34.0009C68.1111 15.2232 52.8889 0.000976562 34.1112 0.000976562C15.3336 0.000976562 0.111328 15.2232 0.111328 34.0009C0.111328 52.7785 15.3336 68.0008 34.1112 68.0008Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_13103_6309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1117 18.1597C25.577 18.1597 18.6572 25.0794 18.6572 33.6142V34.0005C18.6572 25.4658 25.577 18.546 34.1117 18.546H68.1116V18.1597H34.1117Z",
    fill: "#3E2723",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4794 41.7276C44.8057 46.3407 39.8255 49.4548 34.1112 49.4548C28.3931 49.4548 23.4128 46.3407 20.7392 41.7276H20.7238L0.111328 6.36768V6.75404L20.7276 42.1139H20.7431C23.4167 46.7271 28.3969 49.8412 34.1151 49.8412C39.8294 49.8412 44.8096 46.731 47.4832 42.1139H47.5026V41.7276H47.4794Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M34.4979 18.5459C34.4322 18.5459 34.3704 18.5536 34.3047 18.5575C42.7506 18.6618 49.566 25.5313 49.566 34.0004C49.566 42.4695 42.7506 49.339 34.3047 49.4433C34.3704 49.4433 34.4322 49.4549 34.4979 49.4549C43.0326 49.4549 49.9524 42.5351 49.9524 34.0004C49.9524 25.4657 43.0326 18.5459 34.4979 18.5459Z",
    fill: "#3E2723"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6336 42.2413C48.9472 39.9695 49.7083 37.3422 49.7083 34.5295C49.7083 32.8991 49.4533 31.3304 48.9858 29.8584C49.3529 31.1798 49.5654 32.5668 49.5654 34.0041C49.5654 36.8168 48.8042 39.4441 47.4906 41.7159L47.4983 41.7313L32.4766 68.004H32.9247L47.6413 42.2568L47.6336 42.2413Z",
    fill: "white",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_13103_6309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 69,
    height: 69
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1112 68.0008C52.8889 68.0008 68.1111 52.7785 68.1111 34.0009C68.1111 15.2232 52.8889 0.000976562 34.1112 0.000976562C15.3336 0.000976562 0.111328 15.2232 0.111328 34.0009C0.111328 52.7785 15.3336 68.0008 34.1112 68.0008Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_13103_6309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1112 0.387339C52.8228 0.387339 68.0029 15.5057 68.1073 34.1941C68.1073 34.1284 68.1111 34.0666 68.1111 34.0009C68.1111 15.2237 52.8884 0.000976562 34.1112 0.000976562C15.334 0.000976562 0.111328 15.2237 0.111328 34.0009C0.111328 34.0666 0.115192 34.1284 0.115192 34.1941C0.21951 15.5057 15.3997 0.387339 34.1112 0.387339Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1112 67.6143C52.8228 67.6143 68.0029 52.496 68.1073 33.8076C68.1073 33.8733 68.1111 33.9351 68.1111 34.0008C68.1111 52.778 52.8884 68.0007 34.1112 68.0007C15.334 68.0007 0.111328 52.778 0.111328 34.0008C0.111328 33.9351 0.115192 33.8733 0.115192 33.8076C0.21951 52.496 15.3997 67.6143 34.1112 67.6143Z",
    fill: "#3E2723",
    fillOpacity: 0.15
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1122 67.9998C52.8898 67.9998 68.1121 52.7775 68.1121 33.9999C68.1121 15.2223 52.8898 0 34.1122 0C15.3346 0 0.112305 15.2223 0.112305 33.9999C0.112305 52.7775 15.3346 67.9998 34.1122 67.9998Z",
    fill: "url(#paint9_radial_13103_6309)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13103_6309",
    x1: 8.3561,
    y1: 25.8954,
    x2: 28.6401,
    y2: 14.0468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A52714",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A52714",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13103_6309",
    x1: 39.8564,
    y1: 60.4661,
    x2: 17.3191,
    y2: 47.2641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#055524",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#055524",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13103_6309",
    x1: 44.1012,
    y1: 16.1525,
    x2: 49.7769,
    y2: 41.0056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA6100",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EA6100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13103_6309",
    x1: 44.1022,
    y1: 16.152,
    x2: 49.7779,
    y2: 41.0051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA6100",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EA6100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13103_6309",
    x1: 8.35512,
    y1: 25.8954,
    x2: 28.6391,
    y2: 14.0468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A52714",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A52714",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_13103_6309",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.6354 18.5258) scale(32.4846 32.4846)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2723",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E2723",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_13103_6309",
    x1: 39.8574,
    y1: 60.4671,
    x2: 17.3201,
    y2: 47.2651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#055524",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#055524",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_13103_6309",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.47499 15.6564) scale(30.1533 30.1533)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2723",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E2723",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_13103_6309",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.0493 34.0536) scale(33.9497 33.9497)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_13103_6309",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.2682 9.27811) scale(68.2896)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChrome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chrome.b54ddc5e54da73b541c2128720876893.svg";